import { useContext } from 'react';
import { SmartPropertiesContext } from './context';
import { isContact } from '../../../utils';
import { useEnrichmentPolicy } from '../../../EnrichmentPolicy/useEnrichmentPolicy';
export function useSmartProperties() {
  const {
    policy: enrichmentPolicy
  } = useEnrichmentPolicy();
  const machine = useContext(SmartPropertiesContext);
  if (!machine) {
    throw new Error('useSmartProperties must be used within SmartPropertiesPanelProvider');
  }
  const {
    state,
    send
  } = machine;
  const {
    enrichmentType
  } = state.context;
  const hasAccessBilling = enrichmentPolicy.accessBilling();
  const onSelect = propertyNames => send({
    type: 'SELECT_PROPERTIES',
    data: {
      propertyNames
    }
  });
  const onSetFillOption = fillOption => send({
    type: 'SET_FILL_OPTIONS',
    data: {
      fillOption
    }
  });
  return {
    canEnrich: state.context.selectedProperties.length > 0,
    errorId: state.context.errorId,
    fillOption: state.context.fillOption,
    hasAccessBilling,
    isContactEnrichment: isContact(enrichmentType),
    isError: state.hasTag('error'),
    isErrorCredits: state.matches('errorCredits'),
    isErrorEnrichment: state.matches('errorEnrichment'),
    isLoading: state.hasTag('loading') || !enrichmentPolicy.isLoaded,
    onClose: state.context.onClose,
    onEnrich: () => send('ENRICH'),
    onRetry: () => send('RETRY'),
    onSelect,
    onSetFillOption,
    properties: state.context.properties,
    selectedProperties: state.context.selectedProperties
  };
}